import React, {Component} from 'react';
import {observer} from "mobx-react";
import GridGallery from "../../Helpers/GridGallery/GridGallery";
import AttachmentSpoiler from "./AttachmentSpoiler";
import LazyBlock from "../../Helpers/LazyBlock";
import Aspect from "../../Helpers/Aspect";
import uid from "../../../utils/generateUid";
import webp from "../../../utils/webp";
import LazyImg from "../../Helpers/LazyImg";
import LazyBg from "../../Helpers/LazyBg";


class MyPhotos extends Component {
  showMyPhoto(item) {
    if(typeof window.toWar_forPopup !== 'undefined') {
      window.toWar_forPopup.setMemory(window.toWar_forPopup.megaObToUri({popup: `/photos/${item.id}` }));
    }
  }
  renderGrid() {
    const images=this.props.data.list.map((item)=>{
      return (
        <div className="cell" onClick={()=>{ this.showMyPhoto(item); }}>
          <Aspect className="pr" img={this.props.data.list[0]}>
            <LazyBg className="pa pa-tl bg-w2 rad4 ofh pointer w100 h100" style={{backgroundPosition:'center center',backgroundSize:'contain', backgroundRepeat:'no-repeat',backgroundImage:`url('/autoresize/300x0${item.path}')`}} />
          </Aspect>
        </div>
      )
    });
    return (
      <div className="up12 margin s-size-5">
        {images}
      </div>
    )
  }
  isOne() {
    return this.props.data.list && this.props.data.list.length == 1;
  }
  render() {
    if(this.props.data.spoiler && !this.props.data.show_spoiler) {
      return (
        <AttachmentSpoiler data={this.props.data} />
      )
    }
    return (
      <div style={{maxWidth:'100%', width: this.isOne()?400:'auto'}} className="center pr">
        <GridGallery listMode={this.isOne()?"chat":"grid"} items={this.props.data.list} index="path" />
      </div>
    )
  }
}

export default observer(MyPhotos);